import type { ComponentProps } from "react"

export default function IndustryH(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M9.34796 5.49995L4.13996 7.81461L16 13.2039L20.5853 11.1199L9.34796 5.49995ZM23.708 9.69995L27.8586 7.81461L16.5413 2.78395C16.3711 2.7075 16.1866 2.66797 16 2.66797C15.8133 2.66797 15.6289 2.7075 15.4586 2.78395L12.504 4.09728L23.708 9.69995ZM17.3333 15.5266V28.8679L28.5413 23.8866C28.7773 23.7818 28.9777 23.6107 29.1183 23.3941C29.2589 23.1775 29.3336 22.9248 29.3333 22.6666V10.0719L17.3333 15.5266ZM14.6666 15.5266L2.66663 10.0719V22.6666C2.66659 22.9246 2.7414 23.177 2.88198 23.3933C3.02256 23.6097 3.22287 23.7805 3.45863 23.8853L14.6666 28.8679V15.5266ZM5.33329 18.6666V14.6666L12 17.3333V21.3333L5.33329 18.6666Z"
        fill={fill}
      />
    </svg>
  )
}
